function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.4 2a4 4 0 01-8 0h8z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4 6v28M7.9 30c0 9 10-6 19.6 4 10.4-10 19.4 5 19.4-4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  transform: "translate(.15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 34.1c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4H25z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.287,
  cy: 40.7,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.287,
  cy: 43.7,
  r: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 49.2c0 1.367.353 2.392.787 2.392.435 0 .788-1.025.788-2.392s-.788-2.475-.788-2.475-.787 1.108-.787 2.475z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.437 38.2v9"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.6 26c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4h-4.5z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.234 23.478c0 2.528.723 2.423 1.615 2.423.893 0 1.616.105 1.616-2.423s-1.616-4.577-1.616-4.577-1.615 2.049-1.615 4.577z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46.9,
  cy: 35.375,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46.9,
  cy: 38.375,
  r: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.113 43.875c0 1.367.353 2.392.787 2.392.435 0 .788-1.025.788-2.392S46.9 41.4 46.9 41.4s-.787 1.108-.787 2.475z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M46.9 30.475v11.4"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.7 26c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4H5.7zM6.334 23.478c0 2.528.724 2.423 1.616 2.423.892 0 1.615.105 1.615-2.423S7.95 18.901 7.95 18.901s-1.616 2.049-1.616 4.577z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.7 26c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4H5.7zM6.334 23.478c0 2.528.724 2.423 1.616 2.423.892 0 1.615.105 1.615-2.423S7.95 18.901 7.95 18.901s-1.616 2.049-1.616 4.577z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.9,
  cy: 35.375,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.9,
  cy: 38.375,
  r: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.113 43.875c0 1.367.352 2.392.787 2.392.435 0 .787-1.025.787-2.392S7.9 41.4 7.9 41.4s-.787 1.108-.787 2.475z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.9 30.475v11.4"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  transform: "translate(-.175)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6 24c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4h-4.5zM16.234 21.478c0 2.528.723 2.423 1.615 2.423.893 0 1.616.105 1.616-2.423s-1.615-4.577-1.615-4.577-1.616 2.049-1.616 4.577z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 24c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4h-4.5zM16.234 21.478c0 2.528.723 2.423 1.615 2.423.893 0 1.616.105 1.616-2.423s-1.615-4.577-1.615-4.577-1.616 2.049-1.616 4.577z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.9,
  cy: 33.075,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.9,
  cy: 36.075,
  r: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.113 41.575c0 1.367.353 2.392.787 2.392.435 0 .788-1.025.788-2.392S17.9 39.1 17.9 39.1s-.787 1.108-.787 2.475z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.725 28.175v11.4"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  transform: "translate(-.225)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.1 24c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4h-4.5zM35.734 21.478c0 2.528.723 2.423 1.615 2.423.893 0 1.616.105 1.616-2.423s-1.616-4.577-1.616-4.577-1.615 2.049-1.615 4.577z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.1 24c0 2.21 1.007 4 2.25 4s2.25-1.79 2.25-4h-4.5zM35.734 21.478c0 2.528.723 2.423 1.615 2.423.893 0 1.616.105 1.616-2.423s-1.616-4.577-1.616-4.577-1.615 2.049-1.615 4.577z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.4,
  cy: 33.075,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.4,
  cy: 36.075,
  r: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.613 41.575c0 1.367.353 2.392.787 2.392.435 0 .788-1.025.788-2.392S37.4 39.1 37.4 39.1s-.787 1.108-.787 2.475z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.175 28.175v11.4"
}));

var SvgChandelier = function SvgChandelier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChandelier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chandelier.ca7bbd61.svg";
export { ForwardRef as ReactComponent };